define('controllers/ach_schedule',['require'],function(require) {
	return function() {				
	    $(function () {
      var annualCalculationData =
        window.ServerData.feData.annualCalculationData;
      var matchPlanPercentage = `${annualCalculationData.MatchPercent * 100}%`;
      $("[data-matchPlanPercentage]").text(matchPlanPercentage);
			var annualSavings = $("#annualSavings"),
				TextBoxAmount = $("#TextBoxAmountEdit"),
				pnl_WithDrawalDates = $("#pnl_WithDrawalDates"),
				msg = $("#msg_client"),
				isEditMode = TextBoxAmount.length > 0,
				scheduleTypeName = $("#scheduleTypeName"),
				ButtonSaveEdit = $("#ButtonSaveEdit");

			if (isEditMode) {
				function GetPlan() {
					var scheduleTypId = $("#RadioButtonListEditScheduleTypes input:checked").val();

					return $.grep(annualCalculationData.Plans, function (item, index) {
						return item.ScheduleTypeID == scheduleTypId;
					})[0];
				}

				function validatePage(e) {
					var errors = [];

					//validate amount
					var plan = GetPlan(),
						amount = TextBoxAmount.val();

					if (plan != null) { //if the plan they currently have was inactivated, this can happen on edit.
						var validScheduleAmount = amount >= plan.Min_Enforced && amount <= plan.Max_Enforced;

						if (!validScheduleAmount) {
							var amountErrorTemplate = "Amount must be between ${0} and ${1} for a {2} plan.";
							errors.push(amountErrorTemplate.format(plan.Min, plan.Max, plan.Name_Short));
						}

						//make sure selected a schedule date
						var selectedScheduleDate = $("input[name='withdrawalDate']:checked").length > 0;
						if (!selectedScheduleDate) errors.push("Please choose a start date.");

						//prevent post back if invalid
						if (errors.length == 0) {
							$(this).hide().next().fadeIn('slow');
						} else {
							e.preventDefault();
							Utilities.setError(errors.join("<br />"), msg);
							window.scrollTo(0, 0);
						}
					}
				}

				function updateScheduleValidation() {
					var plan = GetPlan(),
						thresholdTemplate = "({0} - {1})";

					if (plan != null) { //if the plan they currently have was inactivated, this can happen on edit.
						$("#ScheduleAmount_Threshold_Info").text(thresholdTemplate.format(plan.Min, plan.Max));
						scheduleTypeName.text(" " + plan.Name_Short);
					}
				}
				updateScheduleValidation();

				function updatePlanAnnualInfo() {
					//store needed data in JSON object to make simply calculation
					var amountText = TextBoxAmount.val().replace("$", ""),
						amount = amountText;

					if (amount > 0) {
						/*Mimic what happens in EntityDataModel.GlobalUtilities.calculateAnnualSavings*/
						var planPrice = annualCalculationData.PlanPrice,
							matchPercent = annualCalculationData.MatchPercent,
							plan = GetPlan();

						if (plan != null) {
							multiplyTimes = plan.AnnualMultiplyTimes;

							var MoneyInput = amount * multiplyTimes;
							var Contributions = MoneyInput - planPrice;
							var total = roundNumber(planPrice + (Contributions * (1 + matchPercent)), 2);

							if (Contributions < 0) {
								//put in a small number that wouldn't even pay for the match plan, so simply show 0, since the UI won't allow the amount anyway...
								total = 0;
							}

							total = numberWithCommas(total);
							annualSavings.html(total);
						}
					}
				}
				updatePlanAnnualInfo();
				TextBoxAmount.on("keyup", updatePlanAnnualInfo)
							 .on("change", function () {
								 var amountText = TextBoxAmount.val().replace("$", "");
								 TextBoxAmount.val(amountText);
							 });

				ButtonSaveEdit.on("click", function (e) {
					msg.hide();
					if (window.Page_ClientValidate == undefined || Page_ClientValidate()) {
						validatePage.call(this, e);
					} else {
						e.preventDefault();
					}
				});

				$("#RadioButtonListEditScheduleTypes input[type='radio']").on("change", function () {
					msg.hide();
					ButtonSaveEdit.prop('disabled', true);

					var postData = {
						method: "RetrieveWithDrawalDates",
						ScheduleTypeId: $(this).val()
					};
					$.post("/myaccount/schedule/ach_scheduleajax.aspx", postData, function (response) {
						Utilities.handleAJAXResponse(response, function (withDrawalDateRadios) {
							pnl_WithDrawalDates.html(withDrawalDateRadios.radios);
						}, function (error) {
							Utilities.setError(error, msg);
						});
					}).error(function () {
						Utilities.setError("Something went wrong while retrieving dates. Please reload the page and try again.", msg);
					}).complete(function () {
						ButtonSaveEdit.prop('disabled', false);
					});

					updatePlanAnnualInfo();
					updateScheduleValidation();
				});

				$("#popupTrigger").fancybox({
				    autoSize: true
				}).trigger("click");

				Utilities.setDefaultButton($("#editContainer"), $("#ButtonSaveEdit"));
			}
		});
	};
});
